import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73eca9ad"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "apollo-playground" }
const _hoisted_2 = {
  key: 0,
  class: "panel"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "query" }, "Query:", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "variables" }, "Variables:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Click the buttons and see the console", -1))
const _hoisted_6 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "toggle",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpen = !_ctx.isOpen))
    }, _toDisplayString(_ctx.isOpen ? 'Hide' : 'Show') + " Apollo PlayGround", 1),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.isOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _withDirectives(_createElementVNode("textarea", {
                id: "query",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query) = $event)),
                placeholder: "Enter your GraphQL query here"
              }, null, 512), [
                [_vModelText, _ctx.query]
              ]),
              _hoisted_4,
              _withDirectives(_createElementVNode("textarea", {
                id: "variables",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.variables) = $event)),
                placeholder: "Enter variables as a JSON object"
              }, null, 512), [
                [_vModelText, _ctx.variables]
              ]),
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.sendQuery && _ctx.sendQuery(...args)))
                }, "Query"),
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.sendMutation && _ctx.sendMutation(...args)))
                }, "Mutate")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}